import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
  getAllSportData,
  addFormData,
  getAllPaymentFilterData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import DeleteModel from "../../components/DeleteModel";
import SearchIcon from "@mui/icons-material/Search";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Col, Row, Container } from "react-bootstrap";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import successicon from "../../assests/payments_icon/success.png";
import pendingicon from "../../assests/payments_icon/pending.png";
import canceicon from "../../assests/payments_icon/cancel.png";
import UserDetails from "../User/UserList/UserDetails";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      {/* <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton> */}

      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>

      {/* <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton> */}
    </Box>
  );
}

const Payments = () => {
  const [editData, setEditData] = useState({});
  const [createData, setCreateData] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [giftItem, setGiftItem] = useState("");
  const [claimDate, setClaimDate] = useState("");
  const [processDate, setProcessDate] = useState("");
  const [trackingCode, setTrackingCode] = useState("");
  const [status, setStatus] = useState(null);
  const [price, setPrice] = useState(null);
  const [giftCopy, setgiftCopy] = useState(null);
  const [termConditions, setTermConditions] = useState(null);

  const userInfo = useSelector((state) => state.auth);

  const [pending, setPending] = useState(true);
  const [cancleShow, setCancleShow] = useState(false);
  const [checkShow, setCheckShow] = useState(false);
  const [pauseShow, setPauseShow] = useState(false);
  const [viewShow, setViewShow] = useState(false);

  const [rows, setRows] = useState([]);

  const [transData, setTransData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleViewClose = () => setViewShow(false);
  const handleCancleClose = () => setCancleShow(false);
  const handlePauseClose = () => setPauseShow(false);
  const handleCheckClose = () => setCheckShow(false);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalcount, setTotalCount] = useState(1);

  const [userId, setUserId] = useState("");
  const [Transtype, setTransType] = useState("");
  const [username, setuserName] = useState("");
  const [name, setName] = useState("");

  // Avoid a layout jump when reaching the last page with empty rows.

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const emptyRows = 0;

  useEffect(() => {
    paymentsData(1, filteredData);
  
  }, []);

  // withdrawl payments get api call
  const paymentsData = async (page, data) => {
    let url = `${endPoints.api.WITHDRAW_TRANSACTIONS}/${page}/${rowsPerPage}`;
    setIsLoading(true);
    await getAllFilterData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          let data = response.data;
          setRows(response.data);
          // console.log("data row",response.data.type);
          setPending(false);
          const ITEMS_PER_PAGE = rowsPerPage;
          setTotalCount(data[0]?.totalcount);
          const totalCount = data[0]?.totalcount;
          const totalPagesCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
          setTotalPages(totalPagesCount);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const getTransactionDetails = async (custId) => {

      let url = `${endPoints.api.GET_TRANSACTION_DETAILS}/${custId}`;
      setIsLoading(true);
      await getAllData(url)
        .then((response) => {
          setIsLoading(false);
          if (response.status === "success") {
            setTransData(response.data);
          } else {
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
        });
  
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
    paymentsData(newPage + 1, filteredData);
  };

  const handleChangeRowsPerPage = (event, newPage) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
  };

  useEffect(() => {
    paymentsData(page, filteredData);
  }, [rowsPerPage]);

  useEffect(() => {
    if (editData) {
      setCustomerId(editData.customer_id || "");
      setGiftItem(editData.gift_item || "");
      setClaimDate(
        editData.claim_date
          ? moment(editData.claim_date).format("YYYY-MM-DD")
          : ""
      );
      setProcessDate(
        editData.process_date
          ? moment.utc(editData.process_date).format("YYYY-MM-DD")
          : ""
      );
      setTrackingCode(editData.tracking_code || "");
      setStatus(editData.status || "");
      setPrice(editData.price || "");
      setgiftCopy(editData.gift_copy || "");
      setTermConditions(editData.terms_condition || "");
    }
  }, [editData]);

  let filteredData = {
    userId: userId,
    status: Transtype,
    name: name,
    userName: username,
  };

  const [filteredRows, setFilteredRows] = useState(rows);
  const [filterValue, setFilterValue] = useState("");

  // const [sortConfig, setSortConfig] = useState({ key: 'customer_id', direction: 'ascending' });

  // const handleSort = (key) => {
  //     let direction = 'ascending';
  //     if (sortConfig.key === key && sortConfig.direction === 'ascending') {
  //         direction = 'descending';
  //     }
  //     setSortConfig({ key, direction });
  // };

  const handleFilterChange = (event) => {
    const newFilterValue = event.target.value.toLowerCase();
    setFilterValue(newFilterValue);

    if (newFilterValue === "") {
      setFilteredRows(rows);
    } else {
      const filteredData = rows.filter((item) =>
        item.gift_item.toLowerCase().includes(newFilterValue)
      );
      setFilteredRows(filteredData);
    }
  };

  // const sortedRows = React.useMemo(() => {
  //     let sortableItems = [...rows];
  //     if (sortConfig !== null) {
  //         sortableItems.sort((a, b) => {
  //             if (a[sortConfig.key] < b[sortConfig.key]) {
  //                 return sortConfig.direction === 'ascending' ? -1 : 1;
  //             }
  //             if (a[sortConfig.key] > b[sortConfig.key]) {
  //                 return sortConfig.direction === 'ascending' ? 1 : -1;
  //             }
  //             return 0;
  //         });
  //     }
  //     return sortableItems;
  // }, [rows, sortConfig]);
  const rowsToDisplay = filterValue.length > 0 ? filteredRows : rows;

  // console.log(sortedRows)

  const Approval = async (alldata) => {
    try {
      let url = `${endPoints.api.TRANSACTION_UPDATE}`;
      let data = {
        id_transaction: alldata.id_transaction,
        id_user: alldata.id_user,
        status: 1,
      };
      setIsLoading(true);
      let response = await getAllFilterData(url, data);
      setIsLoading(false);
      if (response.status == "success") {
        SuccesToast(response.message);
        paymentsData(page, filteredData);
        setCheckShow(false);
      } else {
        ErrorToast(response.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  const Cancel = async (alldata) => {
    try {
      let url = `${endPoints.api.TRANSACTION_UPDATE}`;
      let data = {
        id_transaction: alldata.id_transaction,
        id_user: alldata.id_user,
        status: 3,
      };
      setIsLoading(true);
      let response = await getAllFilterData(url, data);
      setIsLoading(false);
      if (response.status == "success") {
        SuccesToast(response.message);
        paymentsData(page, filteredData);
        setCancleShow(false);
      } else {
        ErrorToast(response.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  const Hold = async (alldata) => {
    try {
      let url = `${endPoints.api.TRANSACTION_UPDATE}`;
      let data = {
        id_transaction: alldata.id_transaction,
        id_user: alldata.id_user,
        status: 2,
      };
      setIsLoading(true);
      let response = await getAllFilterData(url, data);
      setIsLoading(false);
      if (response.status == "success") {
        SuccesToast(response.message);
        paymentsData(page, filteredData);
        setPauseShow(false);
      } else {
        ErrorToast(response.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  const closeView = () => {
    setViewShow(false);
  };

  return (
    <>
      <div className="main">
        <Toaster></Toaster>

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2 heading-table"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Withdrawal Requests
                  </h3>
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                {/* <div className="table_search"> */}
                <Row>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Customer ID</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Customer ID"
                        value={userId}
                        onChange={(e) => setUserId(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter First Name or Last Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Userrname</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Username"
                        value={username}
                        onChange={(e) => setuserName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">
                        Withdrawal Status
                      </Form.Label>
                      <Form.Select
                        onChange={(e) => setTransType(e.target.value)}
                      >
                        <option value="" disabled selected>
                          Select Withdrawal Status
                        </option>
                        <option value="1">Approved</option>
                        <option value="0">Pending</option>
                        <option value="2">Hold</option>
                        <option value="3">Cancelled</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group
                      as={Col}
                      controlId="formName"
                      style={{ marginTop: "30px" }}
                    >
                      <Button
                        variant="primary"
                        style={{
                          width: "70%",
                          background: "#0D3862",
                          borderRadius: "8px",
                        }}
                        onClick={() => paymentsData(1, filteredData)}
                      >
                        Search
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
                {/* </div> */}
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        aria-label="sticky table"
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Customer ID</TableCell>
                            <TableCell align="center">Username</TableCell>
                            <TableCell align="center">First & Last Name </TableCell>
                       
                            <TableCell align="center">Transaction ID</TableCell>
                            <TableCell align="center">
                              Transaction Type
                            </TableCell>
                            <TableCell align="center">Trans Date</TableCell>
                            <TableCell align="center">Amount</TableCell>
                            <TableCell align="center">
                              Withdrawal Status
                            </TableCell>
                            <TableCell align="center">Bet</TableCell>
                            <TableCell align="center">
                              Transaction sources
                            </TableCell>
                            <TableCell align="center">
                              Account Status
                            </TableCell>

                            <TableCell align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                              style={{
                                backgroundColor:
                                  (!row.payWithBet &&
                                    row.depositSource == "Same") ||
                                  (row.payWithBet &&
                                    row.depositSource == "Different")
                                    ? "yellow"
                                    : !row.payWithBet &&
                                      row.depositSource == "Different"
                                    ? "#f36464"
                                    : null,
                              }}
                            >
                              <TableCell align="center">
                                {row.id_user}
                              </TableCell>
                              <TableCell align="center">{row.login}</TableCell>

                              <TableCell align="center">{row.name} {row.surname}</TableCell>
                          
                              <TableCell align="center">
                                {row.id_transaction}
                              </TableCell>
                              <TableCell align="center">
                                {row.type == 24 ? "Corepay" : "Skrill"}
                              </TableCell>
                              <TableCell align="center">
                                {moment
                                  .utc(row.insertion_time)
                                  .format("YYYY-MM-DD")}
                              </TableCell>
                              <TableCell align="center">
                                {row.tamount}
                              </TableCell>
                              <TableCell align="center">
                                {row.transaction_status}
                              </TableCell>
                              <TableCell align="center">
                                {row.payWithBet ? "Yes" : "No"}
                              </TableCell>
                              <TableCell align="center">
                                {row.depositSource}
                              </TableCell>
                              <TableCell align="center">
                              {row.accountSatus}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                }}
                              >
                                <Button
                                  variant="primary"
                                  className="mrglft10"
                                  style={{
                                    background: "#0D3862",
                                    borderRadius: "8px",
                                  }}
                                  onClick={() => {
                                    setViewShow(true);
                                    setCreateData(true);
                                    setEditData(row);
                                    getTransactionDetails(row.id_user)
                                  }}
                                >
                                  View
                                </Button>
                          
                                {row.status == 1 || row.status == 3 ? (
                                  ""
                                ) : (
                                  <>
                                    <img
                                      src={successicon}
                                      style={{ height: "30px" }}
                                      onClick={() => {
                                        setCheckShow(true);
                                        setCreateData(true);
                                        setEditData(row);
                                      }}
                                    />
                                    {row.status == 2 ? (
                                      <img
                                        src={pendingicon}
                                        style={{
                                          height: "30px",
                                          opacity: "30%",
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={pendingicon}
                                        style={{ height: "30px" }}
                                        onClick={() => {
                                          setPauseShow(true);
                                          setCreateData(true);
                                          setEditData(row);
                                        }}
                                      />
                                    )}

                                    <img
                                      src={canceicon}
                                      style={{ height: "30px" }}
                                      onClick={() => {
                                        setCancleShow(true);
                                        setCreateData(true);
                                        setEditData(row);
                                      }}
                                    />
                                  </>
                                )}
                               
                              </TableCell>
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              className="hide-rows-per-page-options"
                              rowsPerPageOptions={[5, 10, 25, 50]}
                              colSpan={12}
                              count={
                                rowsPerPage === -1 ? rows.length : totalcount
                              }
                              rowsPerPage={rowsPerPage}
                              page={page - 1}
                              // count={rowsToDisplay.length}
                              // rowsPerPage={rowsPerPage}
                              // page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <>
                    <Modal
                      show={checkShow}
                      onHide={handleCheckClose}
                      // style={{ marginTop: "10%" }}
                      size="lg"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton></Modal.Header>
                      <Modal.Body>
                        <Container>
                          <Row>
                            <Col xs={12} className="text-center">
                              <h2 style={{ fontSize: "24px" }}>
                                <b>Withdrawal Approval</b>
                              </h2>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <table className="table table-striped">
                                <tbody>
                                  <tr>
                                    <th>Customer ID:</th>
                                    <td>{editData.id_user}</td>
                                    <th>Transaction ID:</th>
                                    <td>{editData.id_transaction}</td>
                                  </tr>
                                  <tr>
                                    <th>Customer Name:</th>
                                    <td>{editData.name}</td>
                                    <th>Transaction Date:</th>
                                    <td>
                                      {moment
                                        .utc(editData.insertion_time)
                                        .format("YYYY-MM-DD")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>User Name:</th>
                                    <td>{editData.login}</td>
                                    <th>Amount:</th>
                                    <td>${editData.tamount}</td>
                                  </tr>
                                  <tr>
                                    <th>Pay Bets</th>
                                    <td>{editData.payBets}</td>
                                    <th>Type:</th>
                                    <td>{editData.wallet_type}</td>
                                  </tr>

                                  <tr>
                                    <th>Total CorePay Deposit</th>
                                    <td>{editData.totalCorePayDeposit}</td>
                                    <th>Total Skrill Deposit:</th>
                                    <td>{editData.totalSkrilDeposit}</td>
                                  </tr>
                                  <tr>
                                    <th>Total CorePay Withdrawal</th>
                                    <td>{editData.totalCoreWithdrawal}</td>
                                    <th>Total Skrill Withdrawal:</th>
                                    <td>{editData.totalSkrilWithdrawal}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12} className="text-center">
                              <p>
                                <b style={{ fontSize: "20px" }}>
                                  Would you like to Approve this transaction?
                                </b>
                              </p>
                              <p style={{ fontSize: "12px" }}>
                                After approval, funds will be sent to the
                                payment provider.
                              </p>
                              <Button
                                variant="primary"
                                size="lg"
                                block
                                style={{
                                  borderRadius: "8px",
                                  background: "#0A9B14",
                                  border: "none",
                                }}
                                onClick={() => {
                                  Approval(editData);
                                }}
                              >
                                Approve Withdrawal
                              </Button>
                            </Col>
                          </Row>
                        </Container>
                      </Modal.Body>
                    </Modal>
                    <Modal
                      show={cancleShow}
                      onHide={handleCancleClose}
                      // style={{ marginTop: "10%" }}
                      size="lg"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton></Modal.Header>
                      <Modal.Body>
                        <Container>
                          <Row>
                            <Col xs={12} className="text-center">
                              <h2 style={{ fontSize: "24px" }}>
                                <b>Withdrawal Cancellation</b>
                              </h2>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <table className="table table-striped">
                                <tbody>
                                  <tr>
                                    <th>Customer ID:</th>
                                    <td>{editData.id_user}</td>
                                    <th>Transaction ID:</th>
                                    <td>{editData.id_transaction}</td>
                                  </tr>
                                  <tr>
                                    <th>Customer Name:</th>
                                    <td>{editData.name}</td>
                                    <th>Transaction Date:</th>
                                    <td>
                                      {moment
                                        .utc(editData.insertion_time)
                                        .format("YYYY-MM-DD")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>User Name:</th>
                                    <td>{editData.login}</td>
                                    <th>Amount:</th>
                                    <td>${editData.tamount}</td>
                                  </tr>
                                  <tr>
                                    <th></th>
                                    <td></td>
                                    <th>Type:</th>
                                    <td>{editData.wallet_type}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12} className="text-center">
                              <p>
                                <b style={{ fontSize: "20px" }}>
                                  Would you like to Cancel this transaction?
                                </b>
                              </p>
                              <p style={{ fontSize: "12px" }}>
                                After cancellation funds will be returned to the
                                player’s account.
                              </p>
                              <Button
                                variant="primary"
                                size="lg"
                                block
                                style={{
                                  borderRadius: "8px",
                                  background: "#ED0100",
                                  border: "none",
                                }}
                                onClick={() => {
                                  Cancel(editData);
                                }}
                              >
                                Cancel Withdrawal
                              </Button>
                            </Col>
                          </Row>
                        </Container>
                      </Modal.Body>
                    </Modal>
                    <Modal
                      show={pauseShow}
                      onHide={handlePauseClose}
                      // style={{ marginTop: "10%" }}
                      size="lg"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton></Modal.Header>
                      <Modal.Body>
                        <Container>
                          <Row>
                            <Col xs={12} className="text-center">
                              <h2 style={{ fontSize: "24px" }}>
                                <b>Place Withdrawal On Hold</b>
                              </h2>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <table className="table table-striped">
                                <tbody>
                                  <tr>
                                    <th>Customer ID:</th>
                                    <td>{editData.id_user}</td>
                                    <th>Transaction ID:</th>
                                    <td>{editData.id_transaction}</td>
                                  </tr>
                                  <tr>
                                    <th>Customer Name:</th>
                                    <td>{editData.name}</td>
                                    <th>Transaction Date:</th>
                                    <td>
                                      {moment
                                        .utc(editData.insertion_time)
                                        .format("YYYY-MM-DD")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>User Name:</th>
                                    <td>{editData.login}</td>
                                    <th>Amount:</th>
                                    <td>${editData.tamount}</td>
                                  </tr>
                                  <tr>
                                    <th></th>
                                    <td></td>
                                    <th>Type:</th>
                                    <td>{editData.wallet_type}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12} className="text-center">
                              <p>
                                <b style={{ fontSize: "20px" }}>
                                  Would you like to put this transaction on
                                  Hold?
                                </b>
                              </p>
                              <p style={{ fontSize: "12px" }}>
                                This transaction will be held while you
                                investigate. You can return later to approve or
                                cancel.
                              </p>
                              <Button
                                variant="primary"
                                size="lg"
                                block
                                style={{
                                  borderRadius: "8px",
                                  background: "#D66E05",
                                  border: "none",
                                }}
                                onClick={() => {
                                  Hold(editData);
                                }}
                              >
                                Put Withdrawal on Hold
                              </Button>
                            </Col>
                          </Row>
                        </Container>
                      </Modal.Body>
                    </Modal>
                    <Modal
                      show={viewShow}
                      onHide={handleViewClose}
                      // style={{ marginTop: "10%" }}
                      size="xl"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header
                        closeButton
                        style={{ fontSize: "24px", fontWeight: "bold" }}
                      >
                        Withdrawal Details
                      </Modal.Header>
                      <Modal.Body>
                        <Container>
                          <Row>
                            <Col xs={12}>
                              <table className="table table-striped">
                                <tbody>
                                  <tr>
                                    <th>Customer ID:</th>
                                    <td>{editData.id_user}</td>
                                    <th>Transaction ID:</th>
                                    <td>{editData.id_transaction}</td>
                                  </tr>
                                  <tr>
                                    <th>Customer Name:</th>
                                    <td>{editData.name}</td>
                                    <th>Transaction Date:</th>
                                    <td>
                                      {moment
                                        .utc(editData.insertion_time)
                                        .format("YYYY-MM-DD")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>User Name:</th>
                                    <td>{editData.login}</td>
                                    <th>Amount:</th>
                                    <td>${editData.tamount}</td>
                                  </tr>
                                  <tr>
                                    <th>Withdrawal Status:</th>
                                    <td>{editData.transaction_status}</td>
                                    <th>Type:</th>
                                    <td>{editData.wallet_type}</td>
                                  </tr>

                                  {editData.corepay == null ? (
                                    ""
                                  ) : (
                                    <tr>
                                      <th>Account Number:</th>
                                      <td>{editData.corepay.accountnumber}</td>
                                      <th>Routing Number:</th>
                                      <td>{editData.corepay.routingnumber}</td>
                                    </tr>
                                  )}
                                  <tr>
                                    <th>Status Updated:</th>
                                    <td>
                                      {editData.updated_on
                                        ? moment
                                            .utc(editData.updated_on)
                                            .format("YYYY-MM-DD")
                                        : ""}
                                    </td>
                                    <th>Updated By:</th>
                                    <td>{editData.adminname}</td>
                                  </tr>
                                  <tr>
                                    <th>Transaction type:</th>
                                    <td>
                                      {editData.type == 24
                                        ? "Corepay"
                                        : "Skrill"}
                                    </td>
                                    <th>Pay Bets</th>
                                    <td>{editData.payBets}</td>
                                  </tr>

                                  <tr>
                                    <th>Total CorePay Deposit</th>
                                    <td>{editData.totalCorePayDeposit}</td>
                                    <th>Total Skrill Deposit:</th>
                                    <td>{editData.totalSkrilDeposit}</td>
                                  </tr>
                                  <tr>
                                    <th>Total CorePay Withdrawal</th>
                                    <td>{editData.totalCoreWithdrawal}</td>
                                    <th>Total Skrill Withdrawal:</th>
                                    <td>{editData.totalSkrilWithdrawal}</td>
                                  </tr>
                                  <tr>
                                    <th>Account Status</th>
                                    <td>{editData.accountSatus}</td>
                                    <th>Rational : </th>
                                    <td>{editData.reason}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                          </Row>

                          <div className="col-md-12">
                            <TableContainer component={Paper}>
                              <Table
                                className="c_table"
                                size="small"
                                aria-label="a dense table"
                                stickyHeader
                                sx={{ minWidth: 500 }}
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell align="center">
                                      Deposit Date
                                    </TableCell>
                                    <TableCell align="center">
                                      Deposit Amount
                                    </TableCell>
                                    <TableCell align="center">
                                      Deposit Source{" "}
                                    </TableCell>
                                    <TableCell align="center">
                                      Withdrawal Date
                                    </TableCell>
                                    <TableCell align="center">
                                      Withdrawal Amount
                                    </TableCell>
                                    <TableCell align="center">
                                      Withdrawal Source
                                    </TableCell>
                                    <TableCell align="center">
                                      Bet Date
                                    </TableCell>
                                    <TableCell align="center">
                                      Bet Amount
                                    </TableCell>
                                    <TableCell align="center">
                                      Transaction Status
                                     
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {transData.map((row) => (
                                    <TableRow
                                      key={row.id}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      <TableCell align="center">
                                        {moment
                                          .utc(row.insertion_time)
                                          .format("YYYY-MM-DD")}
                                      </TableCell>
                                      <TableCell align="center">
                                        {row.source == "Skrill"
                                          ? row.skrilDeposit
                                          : row.source == "CorePay"
                                          ? row.corePayDeposit
                                          : ""}
                                      </TableCell>
                                      <TableCell align="center">
                                        {row.source}
                                      </TableCell>
                                      <TableCell align="center">
                                        {moment
                                          .utc(row.insertion_time)
                                          .format("YYYY-MM-DD")}
                                      </TableCell>
                                      <TableCell align="center">
                                      {row.source == "Skrill"
                                          ? row.skrilWithdrawal
                                          : row.source == "CorePay"
                                          ? row.coreWithdrawal
                                          : ""}
                                      </TableCell>
                                      <TableCell align="center">
                                        {row.source}
                                      </TableCell>
                                      <TableCell align="center">
                                        {moment
                                          .utc(row.insertion_time)
                                          .format("YYYY-MM-DD")}
                                      </TableCell>
                                      <TableCell align="center">
                                        {row.payBets}
                                      </TableCell>
                                      <TableCell align="center">
                                        {row.transaction_satus}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </div>

                          <Row>
                            <Col xs={12} className="text-center">
                              <Button
                                variant="primary"
                                size="lg"
                                block
                                style={{ width: "30%", marginTop: "20px" }}
                                onClick={closeView}
                              >
                                Close
                              </Button>
                            </Col>
                          </Row>
                        </Container>
                      </Modal.Body>
                    </Modal>
                  </>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "20px",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Payments;
